import { render, staticRenderFns } from "./AboutDetail.vue?vue&type=template&id=17ac7642&"
import script from "./AboutDetail.vue?vue&type=script&lang=js&"
export * from "./AboutDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports